/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SpecialOrderMaterialOperationEnum {
    CANCEL = 'CANCEL',
    DELETE = 'DELETE'
}
